import { useParams } from "react-router-dom";
import { legalDocs } from "@/data/legal";
import { useDocumentMeta } from "@/hooks/useDocumentMeta";
import { SectionEyebrow } from "@/components/ui/SectionEyebrow";
import { NotFoundPage } from "./NotFound";

export function LegalPage() {
  const { slug } = useParams<{ slug: string }>();
  const doc = slug ? legalDocs[slug] : undefined;

  useDocumentMeta(
    doc ? `${doc.title} | The Planet` : "Page Not Found | The Planet",
    doc ? `${doc.title} for The Planet's hosting, cloud and infrastructure services.` : ""
  );

  if (!doc) return <NotFoundPage />;

  return (
    <section className="mx-auto max-w-3xl px-5 py-20 lg:px-8">
      <SectionEyebrow>Legal</SectionEyebrow>
      <h1 className="mt-5 font-display text-3xl font-semibold text-text-primary sm:text-4xl">
        {doc.title}
      </h1>
      <p className="mt-2 font-mono text-xs text-text-muted">Last updated: {doc.lastUpdated}</p>

      <div className="mt-10 space-y-8">
        {doc.sections.map((s) => (
          <div key={s.heading}>
            <h2 className="font-display text-lg font-semibold text-text-primary">{s.heading}</h2>
            <p className="mt-2.5 text-sm leading-relaxed text-text-secondary">{s.body}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
